import { InjectionToken } from '@angular/core'
import { QueryParamMap } from './queryparams.interface'

export const FLO_INITIAL_QUERY_PARAM_MAP = new InjectionToken<QueryParamMap>('flo.queryparams.initial')
